import { render, staticRenderFns } from "./IndividualsSummary.vue?vue&type=template&id=10d0d6fe&scoped=true"
import script from "./IndividualsSummary.vue?vue&type=script&lang=js"
export * from "./IndividualsSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d0d6fe",
  null
  
)

export default component.exports